module.exports = __webpack_public_path__ + "8a8e9e53fc1ca92e6a543fee0ce1ac26.png";